import { useRef, useState } from 'react'
import { useSearchStore } from '@/shared/store/useSearchStore'
import useFilteredBySearchChannels from '@/components/tv/hooks/useFilteredChannelsHook'
import { useSearchResult } from '@/features/VOD/hooks/useSearchResult'
import Channel from '@/shared/classes/channels/channel'
import { channelType, cutvType, vodContentType } from '@/shared/constants'

export const usePopperSearchResultsLogic = (
    channels: Array<Channel>,
    query: string
) => {
    const [isShowMoreVod, setIsShowMoreVod] = useState(false)
    const [isShowMoreCatchup, setIsShowMoreCatchup] = useState(false)
    const [isShowMoreTV, setIsShowMoreTV] = useState(false)
    const [isShowMoreEpg, setIsShowMoreEpg] = useState(false)
    const { searchValue } = useSearchStore()

    const ref = useRef<HTMLDivElement | null>(null)

    const searchResults = useSearchResult(query)

    const normalizeType = (type: string) => type.toLowerCase()

    const vodSearchResults = searchResults.filter(({ internalDeepLinkType }) =>
        vodContentType.includes(normalizeType(internalDeepLinkType))
    )
    const catchupSearchResults = searchResults.filter(
        ({ internalDeepLinkType }) =>
            normalizeType(internalDeepLinkType) === cutvType
    )
    const channelSearchResults = searchResults.filter(
        ({ internalDeepLinkType }) =>
            normalizeType(internalDeepLinkType) === channelType
    )

    const { finallyFiltered } = useFilteredBySearchChannels(
        channels,
        searchValue
    )
    const searchChannelIds = channelSearchResults.map((result) =>
        result.internalDeepLinkContentId.toString()
    )

    // Step 2: Filter the Channel array based on matching IDs
    const channelsFuturePlaying = channels.filter((channel) =>
        searchChannelIds.includes(channel.id.toString())
    )

    const container = {
        overflowX: 'hidden',
        width: '100vw',
        maxWidth: {
            xs:
                isShowMoreVod || isShowMoreCatchup || isShowMoreTV
                    ? '86vw'
                    : '409px',
            lg:
                isShowMoreVod || isShowMoreCatchup || isShowMoreTV
                    ? '780px'
                    : '409px',
        },
    }

    return {
        isShowMoreVod,
        isShowMoreCatchup,
        isShowMoreTV,
        isShowMoreEpg,
        ref,
        setIsShowMoreVod,
        setIsShowMoreCatchup,
        setIsShowMoreTV,
        setIsShowMoreEpg,
        finallyFiltered,
        channelsFuturePlaying,
        vodSearchResults,
        catchupSearchResults,
        channelSearchResults,
        container,
    }
}
